import { useSelector } from 'react-redux'
import { selectBombBombOpen } from '../../store/slices/bombBomb'
import { BombBombButton } from './BombBombButton/BombBombButton'
import { BombBombPanelContent } from './BombBombPanelContent/BombBombPanelContent'

export const BombBomb = () => {
  const open = useSelector(selectBombBombOpen)

  return open ? <BombBombPanelContent /> : <BombBombButton />
}
